<template>
    <div class="absolute inset-0 w-full h-full" @click="playVideo">
        <transition name="fade">
            <div v-if="!playerReady" class="absolute inset-0 w-full h-full z-10">
                <slot></slot>
                <button @click="playVideo" class="absolute top-1/2 left-1/2 transform -translate-x-1/2 z-20" :class="isCompact ? '-translate-y-[60%]' : '-translate-y-1/2'" :aria-label="playLabel">
                    <div class="bg-brand-lime relative z-20 text-brand-teal flex items-center justify-center cursor-pointer" :class="isCompact ? 'rounded-full h-[58px] w-[58px] shadow-[0_8px_20px_rgba(0,0,0,.3)]' : 'rounded-[2em] h-24 w-36 shadow-lg'">
                        <svg :class="isCompact ? 'size-5' : 'size-8'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M187.2 100.9C174.8 94.1 159.8 94.4 147.6 101.6C135.4 108.8 128 121.9 128 136L128 504C128 518.1 135.5 531.2 147.6 538.4C159.7 545.6 174.8 545.9 187.2 539.1L523.2 355.1C536 348.1 544 334.6 544 320C544 305.4 536 291.9 523.2 284.9L187.2 100.9z"></path></svg>
                    </div>
                </button>
            </div>
        </transition>

        <div v-if="clicked" class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
            <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
                <div class="wistia_embed wistia_async_zyqsfis7fy videoFoam=true" style="height:100%;position:relative;width:100%">
                    <div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
                        <img src="https://fast.wistia.com/embed/medias/zyqsfis7fy/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" />
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="absolute inset-0 w-full h-full"></div> <!-- preserve the document flow -->
    </div>
</template>

<script>

export default {
    props: {
        split: {
            type: String,
            default: '',
        },

        /**
         * 'compact' renders a small circular play button nudged above centre so
         * it clears a duration badge in the bottom corner; default is the wide pill.
         */
        variant: {
            type: String,
            default: '',
            validator: (value) => ['', 'compact'].includes(value),
        },

        playLabel: {
            type: String,
            default: 'Play video',
        },
    },

    computed: {
        isCompact() {
            return this.variant === 'compact';
        },
    },

    data() {
        return {
            clicked: false,
            playerReady: false,
            playerOptions: {
                videoId: '391066907',
                options: {
                    title: 0,
                    byline: 0,
                    portrait: 0,
                    responsive: true,
                    autoplay: true
                },
            }
        }
    },

    created() {
        window._wq = window._wq || [];
        _wq.push({ id: 'zyqsfis7fy', onReady: (video) => {
            this.playerReady = true;
        }});

        // pause the video whenever lead capture step changes
        this.$event.$on('step:on-step', (step) => {
            if (this.$refs.player) {
                this.$refs.player.pause();
            }
        });
    },

    methods: {
        async load_script(src) {
            return new Promise((resolve, reject) => {
                if (document.querySelectorAll(`script[src="${src}"]`).length > 0) {
                    resolve();
                    return;
                }

                const script = document.createElement('script');
                script.src = src;
                script.defer = true;

                script.onload = () => {
                    resolve();
                };

                script.onerror = () => {
                    reject(new Error(`Failed to load script ${src}`));
                };

                document.head.appendChild(script);
            });
        },

        playVideo() {
            this.load_script('https://fast.wistia.com/embed/medias/zyqsfis7fy.jsonp')
                .then(() => this.load_script('https://fast.wistia.com/assets/external/E-v1.js'))
                .then(() => this.clicked = true);
        },

        play () {
        },
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
</style>
